import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

const SUFIJO = 'oneService';

// Rutas en orden de especificidad (las más específicas primero)
const RUTAS = [
  { path: '/servicio/:userId/:serviceId/reservar', titulo: 'Reservar' },
  { path: '/servicio/:userId/:serviceId',          titulo: 'Detalle del servicio' },
  { path: '/user/crear-servicio/:tab',             titulo: 'Crear servicio' },
  { path: '/user/servicio/:id',                    titulo: 'Mis servicios' },
  { path: '/user/pagina/:pageId',                  titulo: 'Mi página' },
  { path: '/user/favoritos/:id',                   titulo: 'Favoritos' },
  { path: '/user/servicios',                       titulo: 'Mis servicios' },
  { path: '/perfil/:idUsuario',                    titulo: 'Perfil' },
  { path: '/pagina/:pageId',                       titulo: 'Página' },
  { path: '/mensajes',                             titulo: 'Mensajes' },
  { path: '/mi-perfil',                            titulo: 'Mi perfil' },
  { path: '/home',                                 titulo: 'Inicio' },
  { path: '/signup-step2',                         titulo: 'Completa tu perfil' },
  { path: '/signup-step3',                         titulo: 'Completa tu perfil' },
  { path: '/signup-last',                          titulo: 'Último paso' },
  { path: '/forgot-pass',                          titulo: 'Recuperar contraseña' },
  { path: '/signup',                               titulo: 'Registrarse' },
  { path: '/privacidad',                           titulo: 'Aviso de privacidad' },
  { path: '/condiciones-uso',                      titulo: 'Condiciones de uso' },
  { path: '/cookies',                              titulo: 'Política de cookies' },
  { path: '/terminos-condiciones',                 titulo: 'Términos y condiciones' },
  { path: '/',                                     titulo: 'Iniciar sesión' },
];

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const ruta = RUTAS.find(r => matchPath({ path: r.path, end: true }, pathname));
    document.title = ruta ? `${ruta.titulo} | ${SUFIJO}` : SUFIJO;
  }, [pathname]);

  return null;
};

export default PageTitle;
